import { render } from "./ScrollTo.vue?vue&type=template&id=07b27670"
import script from "./ScrollTo.vue?vue&type=script&lang=js"
export * from "./ScrollTo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__